import { gsap, TimelineMax, Power2 } from 'gsap';
import ScrollMagic from 'scrollmagic';
import MicroModal from 'micromodal';
import jQuery from 'jquery';
import Barba from '@barba/core';

const Belong = {
  belongController: null,

  belongTilt: function () {
    // jQuery('.js-tilt').tilt({
    //     glare: true,
    //     maxGlare: .5,
    //     maxTilt: 7,
    //     //axis: x
    // })
  },

  optionActive: function () {
    if (!jQuery('.mem-deck__wrapper .mem-option-deck').length) {
      return; // Exit if elements don't exist
    }

    jQuery('.mem-deck__wrapper .mem-option-deck:nth-child(3)').addClass('active');
    jQuery('.mem-option-deck')
      .mouseover(function () {
        jQuery('.mem-option-deck').removeClass('active');
      })
      .mouseout(function () {
        jQuery(this).addClass('active');
      });
  },

  belongMobile: function () {
    if (!jQuery('.mobile-cards .benefits-container').length) {
      return; // Exit if elements don't exist
    }

    jQuery('.mobile-cards .benefits-container').slick({
      arrows: true,
      autoplay: false,
      draggable: false,
      fade: true,
      prevArrow: jQuery('.left-arrow svg'),
      nextArrow: jQuery('.right-arrow svg'),
    });

    if (!jQuery('.mobile-membership-items .mem-deck__wrapper').length) {
      return; // Exit if elements don't exist
    }

    jQuery('.mobile-membership-items .mem-deck__wrapper').slick({
      arrows: true,
      autoplay: false,
      draggable: false,
      fade: true,
      prevArrow: jQuery('.membership.left-arrow svg'),
      nextArrow: jQuery('.membership.right-arrow svg'),
    });
  },

  belongModal: function () {
    MicroModal.init();
  },

  initScrollAnimations: function () {
    console.log('Belong: initializing scroll animations');

    // Make sure we have a controller
    if (!this.belongController) {
      console.log('Creating new ScrollMagic controller for Belong');
      this.belongController = new ScrollMagic.Controller();
    }

    // Run the scroll animations
    try {
      this.scrollAnim();
      console.log('Belong ScrollMagic animations initialized successfully');
    } catch (e) {
      console.error('Error initializing Belong ScrollMagic animations:', e);
    }
  },

  scrollAnim: function () {
    let introTL = new TimelineMax({ paused: true });

    introTL
      .fromTo(
        jQuery('.belong-intro__wrapper .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.belong-intro__wrapper .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.belong-intro__wrapper .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.belong-intro__wrapper .gold-link'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let introHeight = jQuery('.belong-intro__wrapper').outerHeight(true);

    const introScene = new ScrollMagic.Scene({
      triggerElement: '.belong-intro__wrapper',
      duration: introHeight,
      triggerHook: 0.5,
      offset: 0,
    })
      .on('enter', () => {
        introTL.play();
      })
      .on('leave', () => {
        // Empty handler
      });

    let memberTL = new TimelineMax({ paused: true });

    memberTL
      .fromTo(
        jQuery('.membership-options__wrapper .mem-options-intro__container .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.membership-options__wrapper .mem-options-intro__container .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.membership-options__wrapper .mem-options-intro__container .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let memberCardsTL = new TimelineMax({ paused: true });

    memberCardsTL.staggerFromTo(
      jQuery('.mem-deck__wrapper .mem-option-deck'),
      1,
      { y: 8, autoAlpha: 0, ease: Power2.easeIn },
      {
        y: 0,
        autoAlpha: 1,
        ease: Power2.easeIn,
        onComplete: () => {
          gsap.set(jQuery('.mem-deck__wrapper .mem-option-deck'), { clearProps: 'all' });
        },
      },
      0.25
    );

    let memberHeight = jQuery('.membership-options__wrapper').outerHeight(true);

    const memberScene = new ScrollMagic.Scene({
      triggerElement: '.membership-options__wrapper',
      duration: memberHeight,
      triggerHook: 0.5,
      offset: 0,
    }).on('progress', (event) => {
      if (event.progress < 0.28) {
        memberTL.play();
      } else if (event.progress > 0.28 && event.progress < 1) {
        if (memberTL.progress() !== 1) {
          memberTL.play();
        }
        memberCardsTL.play();
      }
    });

    let benefitsTL = new TimelineMax({ paused: true });

    benefitsTL
      .fromTo(
        jQuery('.benefits__wrapper .benefits-intro .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.benefits__wrapper .benefits-intro .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let benefitCardsTL = new TimelineMax({ paused: true });

    benefitCardsTL.staggerFromTo(
      jQuery('.benefits-container .benefits-single'),
      1,
      { y: 8, autoAlpha: 0, ease: Power2.easeIn },
      {
        y: 0,
        autoAlpha: 1,
        ease: Power2.easeIn,
        onComplete: () => {
          gsap.set(jQuery('.benefits-container .benefits-single'), { clearProps: 'all' });
        },
      },
      0.25
    );

    let benefitsHeight = jQuery('.benefits__wrapper').outerHeight(true);

    const benefitsScene = new ScrollMagic.Scene({
      triggerElement: '.benefits__wrapper',
      duration: benefitsHeight,
      triggerHook: 0.5,
      offset: 0,
    }).on('progress', (event) => {
      if (event.progress < 0.28) {
        benefitsTL.play();
      } else if (event.progress > 0.28 && event.progress < 1) {
        if (benefitsTL.progress() !== 1) {
          benefitsTL.play();
        }
        benefitCardsTL.play();
      }
    });

    try {
      this.belongController.addScene([introScene, memberScene, benefitsScene]);
      console.log('Added Belong scenes to controller');
    } catch (e) {
      console.error('Error adding Belong scenes to controller:', e);
    }
  },

  init: function () {
    console.log('Belong.init called');

    // Only initialize components if the corresponding elements exist
    this.optionActive();
    this.belongMobile();
    this.belongModal();

    // Create the controller only if it doesn't exist
    if (!this.belongController) {
      console.log('Creating new ScrollMagic controller in Belong.init');
      this.belongController = new ScrollMagic.Controller();
    }
  },
};

// Setup Barba namespace with modern hooks
const belongHooks = {
  beforeEnter(data) {
    console.log('Belong: beforeEnter', data);

    // Check if the controller exists and destroy it to prevent duplicates
    if (Belong.belongController) {
      try {
        Belong.belongController.destroy(true);
        Belong.belongController = null;
        console.log('Destroyed previous Belong ScrollMagic controller');
      } catch (e) {
        console.error('Error destroying Belong controller:', e);
      }
    }
  },

  enter(data) {
    console.log('Belong: enter', data);

    // Wait for DOM to be fully ready before initializing
    setTimeout(() => {
      Belong.init();
      console.log('Belong.init completed');
    }, 100);
  },

  afterEnter(data) {
    console.log('Belong: afterEnter', data);

    // Wait for styles to be applied and DOM to be stable
    setTimeout(() => {
      if (!window.App.isMobile()) {
        Belong.initScrollAnimations();
      } else {
        console.log('Mobile device detected, skipping scroll animations');
      }
    }, 500);
  },

  leave(data) {
    console.log('Belong: leave', data);

    if (Belong.belongController) {
      try {
        Belong.belongController.destroy(true);
        Belong.belongController = null;
        console.log('Belong controller destroyed during leave');
      } catch (e) {
        console.error('Error destroying Belong controller:', e);
      }
    }
  },
};

// Make hooks available for Barba.js
Belong.barbaHooks = belongHooks;

export default Belong;
